import React from "react";
import "@fontsource/aboreto"; // Font Import
import "./App.css";
import logo from "./assets/logo.png"; // ✅ Ensure this path is correct

function App() {
  return (
    <div className="coming-soon">
      <h1>Coming Soon</h1>
      <img src="/logo.png" alt="Zensify Logo" />
    </div>
  );
}
export default App;